<template>
  <div class="row mt-5">
    <div class="col-1"></div>
    <div class="col-10">
      <base-button v-b-toggle.collapse-desc  block class="btn-primary"> Descuentos</base-button>
      <b-collapse id="collapse-desc">
      <b-card title="Lista de descuentos" sub-title="Crear descuento">

        <div class="row">
          <div class="col-4">
            <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="onSubmit">
                <div class="col-12">
                  <label for="name">Nombre Lista</label>
                  <ValidationProvider name="discount.name" rules="required" v-slot="{ errors }">
                    <input
                        id="name"
                        v-model="discount.name"
                        type="text"
                        class="form-control"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-12">
                  <label for="name">Descripción</label>
                  <ValidationProvider name="discount.description" rules="required" v-slot="{ errors }">
                    <input
                        id="description"
                        v-model="discount.description"
                        type="text"
                        class="form-control"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-12">
                  <label for="name">Porcentaje</label>
                  <ValidationProvider name="discount.percent" rules="required" v-slot="{ errors }">
                    <input
                        id="percent"
                        v-model="discount.percent"
                        type="number"
                        class="form-control"
                        min="0"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-12">
                  <base-button type="primary btn_submit" @click="onSubmit"
                               :disabled="invalid">Guardar
                  </base-button>
                </div>
              </form>
            </ValidationObserver>
          </div>
          <div class="col-8">
            <div class="table-responsive table-flush">
              <base-table class="table align-items-center"
                          thead-classes="table-light"
                          tbody-classes="list"
                          :data="discounts">
                <template slot="columns">
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Porcentaje</th>
                  <th></th>
                </template>
                <template slot-scope="{row}">
                  <th scope="row">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <span class="name mb-0 text-sm">{{ row.name }}</span>
                      </div>
                    </div>
                  </th>
                  <td class="budget">
                    {{ row.description }}
                  </td>
                  <td class="budget">
                    {{ row.percent }}
                  </td>

                  <td>
                    <div class="btn_icon_edit" @click="EditDiscount(row)"></div>
                  </td>

                </template>
              </base-table>
            </div>
          </div>
        </div>

      </b-card>
      </b-collapse>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import {bus} from "@/components/Configuration/bus_configuration";
import {configuration_service} from "@/services/configuration/ConfigurationService";
import {extend, ValidationProvider} from 'vee-validate'
import {ValidationObserver} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import swal from "sweetalert";

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})
export default {
  name: "CreateAndShow",
  components: {ValidationProvider, ValidationObserver},
  data() {
    return {
      discounts: [],
      discount: {
        name: '',
        description: '',
        percent: 0,
      }
    }
  },
  methods: {
    EditDiscount(data) {
      this.discount.name = data.name
      this.discount.description = data.description
      this.discount.percent = data.percent
      this.discount.discounts_id = data.discounts_id
    },
    onSubmit() {
      configuration_service.CreateDiscount(this.discount)
    },
    cleandata() {
      this.discount = {
        name: '',
        description: '',
        percent: 0,
      }
    }
  },
  created() {
    configuration_service.GetAllDiscounts()
    bus.$on('GetAllDiscounts', (response) => {
      this.discounts = response
    })
    bus.$on('CreateDiscount', (response) => {
      configuration_service.GetAllDiscounts()
      this.cleandata()
      if (response) {
        swal({
          icon: "success",
          text: "Se Han Guardado los datos correctamente",
          button: "Aceptar"
        })
      }
    })
  }
}
</script>

<style scoped>

</style>